
import axios from '../wmsAxios'

// 保存
export const save = (data) => {
    return axios({
        url: '/tWavePickTask/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tWavePickTask/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tWavePickTask/findPage',
        method: 'post',
      data
    })
}

// 完成波次总拣
export const completeWavePick = (data) => {
  return axios({
    url: '/tWavePickTask/completeWavePick',
    method: 'post',
    data
  })
}

// 库存短少，重新分配库存
export const pickLocShortage = (data) => {
  return axios({
    url: '/tWavePickTask/pickLocShortage',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tWavePickTask.js